import React from 'react';
import { Formik } from 'formik';
import {
  FormControlLabel,
  Checkbox,
  FormControl,
  FormHelperText,
  Button,
  Theme
} from '@mui/material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { useTranslation } from 'react-i18next';
import { HttpStatuses } from '../types';
import { PersonalizedLoginWithAgreement } from '../lib/services/login';
import { redirect } from '../lib/Utils';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) => ({
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1)
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: '#8bc540',
    '&:hover, &:focus': {
      backgroundColor: '#7aac38'
    }
  }
}));

/**
 * Form with slot and checkbox that confirms slot
 * @param props
 */
export default function(props: {
  children: React.ReactNode;
  label: string;
  webToken: string;
  internalUrl: string;
}) {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Formik
      enableReinitialize={true}
      initialValues={{
        agreements: 'privacy_policy_domrf',
        isAgree: false
      }}
      onSubmit={async (values, { setErrors, setSubmitting }) => {
        const response = await PersonalizedLoginWithAgreement(
          props.webToken,
          props.internalUrl
        );
        if (response.status === HttpStatuses.success) {
          redirect(
            response?.body?.url ? response.body.url : props.internalUrl ?? '/'
          );
        } else {
          setErrors({
            isAgree: t('error')
          });
        }
      }}
      validate={values => {
        let errors: { [key: string]: any } = {};
        if (!values.isAgree) {
          errors.isAgree =
            'Необходимо согласиться на обработку персональных данных';
        }
        return errors;
      }}
    >
      {({ handleSubmit, handleChange, values, errors }) => (
        <form onSubmit={handleSubmit} className={classes.form} noValidate>
          <div style={{ maxHeight: '60vh', overflow: 'auto' }}>
            {props.children}
          </div>
          <FormControl fullWidth margin="normal" error={!!errors.isAgree}>
            <FormControlLabel
              control={
                <Checkbox
                  style={{ color: '#8bc540' }}
                  icon={<CheckBoxOutlineBlankIcon fontSize="medium" />}
                  checkedIcon={
                    <CheckBoxIcon color="inherit" fontSize="medium" />
                  }
                  name="isAgree"
                  onChange={handleChange}
                  checked={values.isAgree}
                />
              }
              label={props.label}
              data-agreement-checkbox
            />
            {errors.isAgree && (
              <FormHelperText>{errors.isAgree}</FormHelperText>
            )}
          </FormControl>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            disabled={!values.isAgree}
          >
            {'Подтвердить'}
          </Button>
        </form>
      )}
    </Formik>
  );
}
